const useBooleanSwitch = (trueCase: any, falseCase: any) => (bool: boolean) => {
  switch (bool) {
    case true:
      return trueCase;
    default:
      return falseCase;
  }
};

export default useBooleanSwitch;
